<script>
    import R, {LOADER} from "../lib/requests";
    import {POINTS_ACTION} from "../lib/constants.js";
    import app from "../stores/app";
    import user from "../stores/user.js";
    import Alert from "../stores/alerts.js";
    import {formatDate, humanDate, memberName} from "../lib/lib.js";
    import PointsPanel from "../account/PointsPanel.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import PageInfo from "../components/pages/PageInfo.svelte";


    let list = null;
    let totalPoints = 0;

    const load = () => {
        const onSuccess = result => {
            list = result;

            list.map(item => {
                if (item.action_id == POINTS_ACTION.ADD) {
                    item.action = item.reason ? item.reason : "Added";
                } else if (item.action_id == POINTS_ACTION.REMOVE) {
                    item.action = item.reason ? item.reason : "Removed";
                } else if (item.action_id == POINTS_ACTION.TRANSFER) {
                    if (item.points < 0) {
                        item.action = 'Transfer to ';
                    } else {
                        item.action = 'Transfer from ';
                    }
                } else if (item.action_id == POINTS_ACTION.SIGNUP) {
                    item.action = 'Sign up';
                } else if (item.action_id == POINTS_ACTION.CHECKIN) {
                    item.action = 'Check in';
                }

                totalPoints += ~~item.points;
            });
        }

        const onFailure = err => {
        }

        R.handle(R.member.pointsLog, [], onSuccess, onFailure, LOADER.POPUP);
    }

    if ($user.token) {
        load();
    }
</script>

<div class="page-header solid">
    <div>
        <h1>My Points</h1>
        {#if totalPoints > 0}
            <div class="subtitle small fw-semibold">{ totalPoints } points</div>
        {/if}
    </div>
</div>
<div class="page">

    {#if list}
        <table class="table table-list">
            <tbody>
            {#each list as item}
                <tr>
                    <td class="points-entry">
                        <div class="points-heading">
                            <div class="points-title">
                                { item.action }
                                {#if item.member}
                                    <b>"{ memberName(item.member) }"</b>
                                {:else if item.hotel}
                                    <b>"{ item.hotel.name }"</b>
                                {/if}
                            </div>
                            <div class="points-date">
                                { humanDate(item.created_at) }
                            </div>
                        </div>
                        <div class="points" class:plus={ item.points > 0 } class:minus={ item.points < 0 }>
                            { item.points }
                        </div>
                    </td>
                </tr>
            {/each}
            </tbody>
        </table>
    {/if}
</div>

<style>

    .points-entry {
        border-color: #e2e8f0;
        padding: 15px 30px;
    }

    .points-heading {
        display: flex;
        justify-content: space-between;
    }

    .points-title {
        color: #1e2971;
    }

    .points-date {
        color: #64748b;
    }

    .points {
        font-size: 1.2rem;
        font-weight: 500;

    }

    .points.plus {
        /*color: #3b82f6;*/
        color: #f59e0b;
    }

    .points.minus {
        color: #ef4444;
    }

    @media (max-width: 576px) {
        .points-heading {
            display: block;
        }

        .points-entry {
            padding: 15px 1rem;
        }

        .points-date {
            color: #64748b;
            font-weight: 100;
            font-size: 0.8rem;
            margin-bottom: 10px;
        }
    }
</style>